import { render, staticRenderFns } from "./AddStackOverflowTags.vue?vue&type=template&id=670b795e"
import script from "./AddStackOverflowTags.vue?vue&type=script&lang=js"
export * from "./AddStackOverflowTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports